import React, { useEffect } from 'react';
import { bool, func, object, string } from 'prop-types';
import Autocomplete from '@airasia/phoenix-components/components/Autocomplete';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import { Variant } from '../../utils/constants';

const AutocompleteValidator = ({
  touched,
  values,
  onChange,
  onBlur,
  onFocus,
  onClick,
  isTrim,
  name,
  errors,
  gtmFieldErrorTracking,
  theme,
  move,
  ...restProps
}) => {
  const error = errors[name] || {};
  useEffect(() => {
    if (error.error && error.errorMsg) {
      gtmFieldErrorTracking &&
        gtmFieldErrorTracking({ name, type: error.type, errors });
    }
    // eslint-disable-next-line
  }, [error.error, error.errorMsg]);

  const handleChange = event => {
    let { value } = event.target;
    if (isTrim && value) {
      value = value.trim();
    }
    onChange(name)(value, event);
  };

  return (
    <PhoenixTheme theme={theme}>
      <Autocomplete
        validateStatus={
          error.error ? Variant.Error : touched[name] ? Variant.Success : null
        }
        validateMessage={error.error ? error.errorMsg : ''}
        {...restProps}
        value={values[name]}
        onChange={handleChange}
        onBlur={onBlur(name)}
        onFocus={onFocus(name)}
        onClick={onClick(name)}
        theme={theme}
        move={move}
      />
    </PhoenixTheme>
  );
};

AutocompleteValidator.propTypes = {
  touched: object.isRequired,
  onChange: func.isRequired,
  onBlur: func.isRequired,
  onFocus: func,
  onClick: func,
  values: object.isRequired,
  errors: object.isRequired,
  name: string.isRequired,
  isTrim: bool,
  gtmFieldErrorTracking: func,
  theme: string,
  move: bool,
};

AutocompleteValidator.defaultProps = {
  isTrim: false,
  autoFocus: false,
  onFocus: () => {},
  onClick: () => {},
};

export default AutocompleteValidator;
